
import { createApiClient } from 'Network/ApiClient';

export const DrugExclusionsAxiosInstance = createApiClient('DrugsExclusions/');


